import styled from '@emotion/styled/macro';
import { colors, animate } from '../../styles/theme';

export default styled('div')`
  .react-sweet-progress {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .react-sweet-progress-symbol {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 35px;
    font-weight: 200;
    margin-left: 5px;
  }

  .react-sweet-progress-symbol-absolute {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    align-items: center;
    justify-content: center;
    transform: translate3d(-50%, -50%, 0);
  }
  .react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
    padding: 0;
    width: 100%;
  }

  .react-sweet-progress-line {
    width: 100%;
    border-radius: 10px;
    background: ${colors.grey.secondary};
  }

  .react-sweet-progress-line-inner {
    position: relative;
    min-height: 10px;
    border-radius: 10px;
    transition: width ${animate.transition} ease;
  }

  .react-sweet-progress-line-inner-status-active:before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 10px;
    background: ${colors.white};
    animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
    content: '';
  }

  @keyframes active-anim {
    0% {
      width: 0;
      opacity: 0.1;
    }
    20% {
      width: 0;
      opacity: 0.5;
    }
    to {
      width: 100%;
      opacity: 0;
    }
  }
`;
